export default __webpack_public_path__ + "images/logoBeautyStat.dd0ff21e4225181bd3c9a971c9939656.svg"